import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import Button from '../button';
import addClassCss from './index.scss';
import TextInput from '../text-input/index';
import RadioButton from '../radiobutton';
import DropDownList from '../dropdown-list/index';
import listStyle from './dropdown-list.scss';
import messages from './messages';
import productEnum from '../../helpers/product-enum';
import { moveFlaggedToFront, newCoursesAvailable, showDefaultCourseAtTop } from '../../helpers/utils';
import {
    DEFAULT_COUNTRY_ID,
    DEFAULT_LEGACY_COURSE_ID,
    DEFAULT_NEW_COURSE_ID,
    DEFAULT_TEACHER_ID,
    DEFAULT_UPF_COURSE_ID,
    DEFAULT_YEAR_GROUP,
    DROPDOWN_OPTION_LENGTH,
    MAX_CLASSNAME_LENGTH
} from '../../constants';

class AddClassForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            enableAddButton: false,
            classroom: props.classroom,
            isSchoolCoursesSelected: false,
            isCurriculumCoursesSelected: false,
            selectedUPFCourse: DEFAULT_LEGACY_COURSE_ID,
            selectedNewCourse: DEFAULT_NEW_COURSE_ID,
            selectedLegacyCourse: DEFAULT_LEGACY_COURSE_ID
        };
        this.handleTextInputOnChange = this.handleTextInputOnChange.bind(this);
    }

    validateModal = () => {
        const { isSaveInProgress, selectedProduct, upfCourses, newCourses } = this.props;
        const { classroom, selectedLegacyCourse, selectedUPFCourse, selectedNewCourse } = this.state;
        const classname = classroom.name.trim();
        let isValidClassroom = (
            classname !== '' &&
            classroom.yearGroup !== DEFAULT_YEAR_GROUP &&
            classroom.countryId !== DEFAULT_COUNTRY_ID &&
            classroom.teacherId !== DEFAULT_TEACHER_ID
        );

        if (selectedProduct.id === productEnum.MATLETICA.id) {
            isValidClassroom = classname !== '' &&
            classroom.yearGroup !== DEFAULT_YEAR_GROUP;
        }

        const hasUPFCourses = upfCourses && upfCourses.length > 0;
        const hasNewCourses = newCourses && newCourses.length > 0;

        const isValidLegacy = selectedLegacyCourse !== DEFAULT_LEGACY_COURSE_ID;
        const isValidUPF = !hasUPFCourses || selectedUPFCourse !== DEFAULT_LEGACY_COURSE_ID;
        const isValidNew = !hasNewCourses || selectedNewCourse !== DEFAULT_NEW_COURSE_ID;

        const enableAddButton =
            isValidClassroom &&
            !isSaveInProgress &&
            isValidLegacy &&
            isValidUPF &&
            isValidNew;

        this.setState({ enableAddButton });
    }

    handleOnSchoolCoursesSelection = () => {
        this.setState({
            isSchoolCoursesSelected: true,
            isCurriculumCoursesSelected: false,
            selectedLegacyCourse: DEFAULT_LEGACY_COURSE_ID
        }, () => {
            this.validateModal();
        });
        this.props.clearProductCourses();
        this.props.getSchoolCourses(this.state.classroom.yearGroup);
    }

    handleOnCurriculumCoursesSelection = () => {
        this.setState({
            isSchoolCoursesSelected: false,
            isCurriculumCoursesSelected: true,
            selectedLegacyCourse: DEFAULT_LEGACY_COURSE_ID
        }, () => {
            this.validateModal();
        });

        this.props.clearProductCourses();
        this.getProductCourses();
    }

    getProductCourses = () => {
        const { classroom: {
            countryId,
            yearGroup
        } } = this.state;

        if (yearGroup !== DEFAULT_YEAR_GROUP && countryId !== DEFAULT_COUNTRY_ID) {
            this.props.getProductCourses(countryId, this.props.selectedProduct.id, yearGroup);
        }
    };

    handleTextInputOnChange = (event) => {
        const { classroom } = this.state;

        this.setState({ classroom: {
            ...classroom,
            [event.target.name]: event.target.value
        } }, () => {
            this.validateModal();
        });
        return true;
    }

    handleListOnChange = (field, value) => {
        const { selectedProduct } = this.props;
        const { classroom } = this.state;

        if (field === 'yearGroup' || field === 'countryId' || field === 'teacherId') {
            this.setState({
                classroom: {
                    ...classroom,
                    courseId: '-1',
                    upfCourseId: '-1',
                    [field]: value
                },
                selectedUPFCourse: DEFAULT_LEGACY_COURSE_ID,
                selectedNewCourse: DEFAULT_NEW_COURSE_ID,
                selectedLegacyCourse: DEFAULT_LEGACY_COURSE_ID
            }, () => {
                const { yearGroup, countryId } = this.state.classroom;

                if (yearGroup !== DEFAULT_YEAR_GROUP && countryId !== DEFAULT_COUNTRY_ID) {
                    this.props.getFilteredUPFCourses(countryId, selectedProduct.id, yearGroup);
                    this.props.getFilteredNewCourses({ productId: selectedProduct.id, countryCode: countryId, yearGroup });
                } else {
                    this.props.clearUPFCourses();
                }

                if (this.state.isSchoolCoursesSelected) {
                    this.handleOnSchoolCoursesSelection();
                } else if (this.state.isCurriculumCoursesSelected) {
                    this.handleOnCurriculumCoursesSelection();
                } else if (selectedProduct.id !== productEnum.MATHLETICS.id) {
                    this.getProductCourses();
                }

                this.validateModal();
            });
        }
    }

    handleOnSubmit = () => {
        const { addClass, selectedProduct } = this.props;
        const { classroom, selectedUPFCourse, selectedLegacyCourse, selectedNewCourse } = this.state;
        const { name, yearGroup, teacherId } = classroom;
        this.setState({ enableAddButton: false });
        const teacherProfileIds = [];

        if (teacherId !== DEFAULT_TEACHER_ID) {
            teacherProfileIds.push(teacherId);
        }

        const addClassRequest = {
            productId: selectedProduct.id,
            name: String(name).trim(),
            yearGroupEnum: yearGroup,
            teacherProfileIds,
            courseId: selectedLegacyCourse,
            upfCourseId: selectedUPFCourse,
            conquestCourseId: selectedNewCourse,
            useUpfSchoolDefault: selectedUPFCourse === DEFAULT_UPF_COURSE_ID
        };

        addClass(addClassRequest);
    }

    renderUPFCourses() {
        const { css, intl, selectedProduct, upfCourses = [] } = this.props;
        const { classroom } = this.state;
        let upfSelector = null;

        if (selectedProduct.id === productEnum.MATHLETICS.id) {
            upfSelector = (<div className={css.courseWrapper}>
                <label
                    className={css.label}
                    htmlFor="upfCourse">{intl.formatMessage(messages.skillQuests)}*</label>
                <DropDownList
                    css={listStyle}
                    disabled={classroom.yearGroup === DEFAULT_YEAR_GROUP || classroom.countryId === DEFAULT_COUNTRY_ID}
                    isLoading={this.props.isUPFCoursesFetching}
                    loadingPlaceholder={intl.formatMessage(messages.loadingCourses)}
                    name="upfCourse"
                    onChange={(name, courseId) => this.handleOnUPFChange(courseId)}
                    optionKey="id"
                    optionLength={DROPDOWN_OPTION_LENGTH}
                    options={showDefaultCourseAtTop(upfCourses, intl.formatMessage(messages.useAdminSelection))}
                    optionText="name"
                    placeholder={upfCourses.length ?
                        intl.formatMessage(messages.selectDefaultCourse) :
                        intl.formatMessage(messages.noCoursesFound)}
                />
            </div>);
        }
        return upfSelector;
    }

    renderNewCourses() {
        const { css, intl, displayNewCourses } = this.props;
        let { newCourses } = this.props;
        const {
            classroom: {
                yearGroup,
                countryId
            }
        } = this.state;

        if (!displayNewCourses) return null;

        if (!newCoursesAvailable(yearGroup, countryId)) {
            newCourses = [];
        }
        return (
            <div className={css.courseWrapper}>
                <label
                    className={css.label}
                    htmlFor="newCourses">{intl.formatMessage(messages.newCourses)}*</label>
                <DropDownList
                    css={listStyle}
                    disabled={yearGroup === DEFAULT_YEAR_GROUP || countryId === DEFAULT_COUNTRY_ID}
                    isLoading={this.props.isNewCoursesFetching}
                    loadingPlaceholder={intl.formatMessage(messages.loadingCourses)}
                    name="newCourses"
                    onChange={(_, courseId) => this.handleOnNewCourseChange(courseId)}
                    optionKey="id"
                    optionLength={DROPDOWN_OPTION_LENGTH}
                    options={moveFlaggedToFront(newCourses, 'isDefault')}
                    optionText="name"
                    placeholder={newCourses.length ?
                        intl.formatMessage(messages.selectDefaultCourse) :
                        intl.formatMessage(messages.noCoursesFound)}
                />
            </div>
        );
    }

    handleOnLegacyChange = (courseId) => {
        this.setState({
            selectedLegacyCourse: courseId
        }, () => {
            this.validateModal();
        });
    }

    handleOnUPFChange = (upfCourseId) => {
        this.setState({
            selectedUPFCourse: upfCourseId
        }, () => {
            this.validateModal();
        });
    }

    handleOnNewCourseChange = (courseId) => {
        const selectedNewCourse = courseId === '-1' ? DEFAULT_NEW_COURSE_ID : courseId;
        this.setState({ selectedNewCourse }, () => {
            this.validateModal();
        });
    }

    render() {
        const {
            css,
            intl,
            isSaveInProgress,
            productCountries,
            productTeachers,
            selectedProduct,
            yearGroups,
            onAddClassCloseModal,
            productCourses,
            isProductCoursesFetching,
            isSchoolCoursesFetching,
            upfCountries
        } = this.props;

        const { classroom, isCurriculumCoursesSelected, isSchoolCoursesSelected } = this.state;

        const isTeacherDropdownDisabled = productCountries && productTeachers.length === 0;

        let countries = [
            ...productCountries,
            ...upfCountries.filter(obj => !productCountries.some(item => item.key === obj.key))
        ];

        countries = countries.sort((a, b) => a.value.localeCompare(b.value));

        const isMathleticsProduct = selectedProduct.id === productEnum.MATHLETICS.id;

        const formContent = (
            <div className={css.addClassComponent}>
                <form className={css.addClassForm}>
                    <div className={css.addClassHeader}> {intl.formatMessage(messages.addClass, { productName: selectedProduct.name })} </div>
                    <div className={css.className}>
                        <label
                            className={css.label}
                            htmlFor="name">{intl.formatMessage(messages.className)}*</label>
                        <TextInput
                            disabled={isSaveInProgress}
                            handleOnChange={this.handleTextInputOnChange}
                            maxLength={MAX_CLASSNAME_LENGTH}
                            name="name"
                            placeholder={intl.formatMessage(isMathleticsProduct ? messages.mathsClass : messages.className)}
                            value={classroom.name}
                        /></div>
                    <div className={css.list}>
                        <label
                            className={css.label}
                            htmlFor="teacherName">{intl.formatMessage(messages.teacher)}*</label>
                        <DropDownList
                            css={listStyle}
                            disabled={isTeacherDropdownDisabled}
                            name="teacherId"
                            onChange={this.handleListOnChange}
                            optionLength={DROPDOWN_OPTION_LENGTH}
                            options={productTeachers}
                            placeholder={intl.formatMessage(messages.select)}
                            value={classroom.teacherId}
                        />
                    </div>
                    <div className={css.yearRow}>
                        <div className={css.year}>
                            <label
                                className={css.label}
                                htmlFor="yearGroup">{intl.formatMessage(messages.grade)}*</label>
                            <DropDownList
                                css={listStyle}
                                name="yearGroup"
                                onChange={this.handleListOnChange}
                                optionKey="yearGroupEnum"
                                options={yearGroups}
                                optionText="shortName"
                                placeholder={intl.formatMessage(messages.select)}
                                value={classroom.yearGroup}
                            />
                        </div>
                        <div className={css.country}>
                            <label
                                className={css.label}
                                htmlFor="countryId">{intl.formatMessage(messages.country)}*</label>
                            <DropDownList
                                css={listStyle}
                                name="countryId"
                                onChange={this.handleListOnChange}
                                optionLength={DROPDOWN_OPTION_LENGTH}
                                options={countries}
                                placeholder={intl.formatMessage(messages.select)}
                                value={classroom.country}
                            />
                        </div>
                    </div>
                    <div className={css.courseWrapper}>
                        <label
                            className={css.label}
                            htmlFor="teacherName">{intl.formatMessage(isMathleticsProduct ? messages.courses : messages.coursesNonMaths)}*</label>
                        {isMathleticsProduct && <fieldset className={css.courseSelectorWrapper} id="courseSelector">
                            <div className={css.customCoursesWrapper}>
                                <RadioButton
                                    id="customCourses"
                                    name="courseSelector"
                                    onChange={this.handleOnSchoolCoursesSelection}
                                    value={intl.formatMessage(messages.customCourses)} />
                                <label htmlFor="customCourses">{intl.formatMessage(messages.customCourses)}</label>
                            </div>
                            <div className={css.curriculumCoursesWrapper}>
                                <RadioButton
                                    id="curriculumCourses"
                                    name="courseSelector"
                                    onChange={this.handleOnCurriculumCoursesSelection}
                                    value={intl.formatMessage(messages.customCourses)} />
                                <label htmlFor="curriculumCourses">{intl.formatMessage(messages.curriculumCourses)}</label>
                            </div>
                        </fieldset>}
                        <DropDownList
                            css={listStyle}
                            disabled={(!isCurriculumCoursesSelected && !isSchoolCoursesSelected && isMathleticsProduct) || classroom.yearGroup === DEFAULT_YEAR_GROUP || classroom.countryId === DEFAULT_COUNTRY_ID}
                            isLoading={isProductCoursesFetching || isSchoolCoursesFetching}
                            loadingPlaceholder={intl.formatMessage(messages.loadingCourses)}
                            name="productCourses"
                            onChange={(name, courseId) => this.handleOnLegacyChange(courseId)}
                            optionLength={DROPDOWN_OPTION_LENGTH}
                            options={productCourses}
                            placeholder={productCourses.length ?
                                intl.formatMessage(messages.selectDefaultCourse) :
                                intl.formatMessage(messages.noCoursesFound)}
                        />
                    </div>
                    {this.renderNewCourses()}
                    {this.renderUPFCourses()}
                    <div className={css.required}>*{intl.formatMessage(messages.required)}</div>
                    <div className={css.actionButtonWrapper}>
                        <Button
                            containerClassName={css.cancelButton}
                            disabled={isSaveInProgress}
                            handleOnClick={onAddClassCloseModal}
                            label={intl.formatMessage(messages.cancel)} />
                        <Button
                            containerClassName={this.state.enableAddButton ? css.addButton : css.addButtonDisabled}
                            disabled={!this.state.enableAddButton}
                            handleOnClick={this.handleOnSubmit}
                            label={intl.formatMessage(messages.add)} />
                    </div>
                </form>
            </div>
        );

        return (
            formContent
        );
    }
}
AddClassForm.propTypes = {
    addClass: PropTypes.func,
    classroom: PropTypes.object,
    css: PropTypes.object,
    intl: intlShape.isRequired,
    isSaveInProgress: PropTypes.bool,
    productCountries: PropTypes.arrayOf(PropTypes.object),
    upfCountries: PropTypes.arrayOf(PropTypes.object),
    productTeachers: PropTypes.arrayOf(PropTypes.object),
    selectedProduct: PropTypes.object,
    yearGroups: PropTypes.arrayOf(PropTypes.object),
    onAddClassCloseModal: PropTypes.func,
    getFilteredUPFCourses: PropTypes.func,
    getFilteredNewCourses: PropTypes.func,
    upfCourses: PropTypes.array,
    newCourses: PropTypes.array,
    getSchoolCourses: PropTypes.func.isRequired,
    productCourses: PropTypes.array,
    getProductCourses: PropTypes.func,
    clearProductCourses: PropTypes.func,
    clearUPFCourses: PropTypes.func,
    isProductCoursesFetching: PropTypes.bool,
    isSchoolCoursesFetching: PropTypes.bool,
    isUPFCoursesFetching: PropTypes.bool,
    isNewCoursesFetching: PropTypes.bool,
    displayNewCourses: PropTypes.bool
};

AddClassForm.defaultProps = {
    productCourses: []
};

export default injectIntl(styleable(addClassCss)(AddClassForm));



// WEBPACK FOOTER //
// ./app/components/add-class/add-class-form.js